export enum RiderTabsEnum {
  RiderDetails = 0,
  Signatures = 1,
  Notes = 2,
  History = 3,
  MobileApp = 4,
  Alerts = 5,
  QrCode = 6,
}

export enum RiderSubTabsEnum {
  RiderPayor = 0,
  AdditionalPayor = 1,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-rider.enum.ts